<n-slide-window [width]="SWITCH.IS_SIMPLE_MODE ? '6.08rem' : '7rem'" [visible]="windowVisible" (onHide)="close()">
    <!-- 标题 -->
    <n-header>
        <h1>{{i18n.createUserTitle}}</h1>
        <n-help-link key="authenticationuserCreate" *ngIf = "!SWITCH.IS_SIMPLE_MODE"></n-help-link>
        <n-help-link key="simplifyunixCreate" *ngIf="SWITCH.IS_SIMPLE_MODE"></n-help-link>
    </n-header>
    <!-- 表单区域 -->
    <form [errorMessage]="errorMessage" [formGroup]="vm" [simpleMode]="SWITCH.IS_SIMPLE_MODE"
        [ngClass]="{ 'form-width-simple': SWITCH.IS_SIMPLE_MODE, 'common-form': !SWITCH.IS_SIMPLE_MODE }">
        <!-- 名称 -->
        <n-form-item [label]="i18n.name" [required]="true">
            <input type="text"
                id="local-unix-auth-user-name"
                autocomplete="off"
                nInput
                formControlName="name"
                [placeholder]="errorMessage.name.rangeByteLength">
        </n-form-item>
        <!-- 所属租户 -->
        <n-form-item [label]="i18n.vStoreLab" *ngIf="!SWITCH.IS_SIMPLE_MODE"
            [required]="!vstore || !vstore.value">
            <n-select #vstoreSelect
                id="vstore_dropdown"
                formControlName="vstoreItem"
                [rest]="vstoreRest"
                [filter]="true"
                [labelField]="'NAME'"
                [valueField]="'ID'"
                style="width: 3rem"
                (onChange)="vstoreItemChange($event)"
                *ngIf="!vstore || !vstore.value">
            </n-select>
            <div class="n-form-item-text" *ngIf="vstore && vstore.value">{{vstore.label}}</div>
        </n-form-item>
        <!-- ID -->
        <n-form-item [label]="i18n.id" [helpContent]="i18n.helpIcon.idForUser">
            <div class="interval-10">
                <n-spinner id="create_local-auth-unix-user-id" [onlyInput]="true" [required]="false" [min]="idRange.min"
                    [max]="idRange.max" formControlName="id">
                </n-spinner>
                <span>{{ i18n.idRange(idRange.min, idRange.max) }}</span>
            </div>
        </n-form-item>
        <!-- 主组 -->
        <n-form-item [label]="i18n.mainGroup" [required]="true">
            <n-input-select id="unix-local-auth-user-mainGroup" [clearBtn]="true" [slideConfig]="primaryGroupConfig"
                formControlName="primary_group_name" [canOpenSlide]="canOpenSlide">
            </n-input-select>
        </n-form-item>
        <!-- 描述 -->
        <n-form-item [label]="i18n.description">
            <textarea id="create_local-auth-unix-user-description"
                nTextarea
                formControlName="description"
                [placeholder]="errorMessage.description.rangeByteLength">
            </textarea>
        </n-form-item>
    </form>
    <!-- 按钮区域 -->
    <n-footer>
        <button id="create-local-unix-user-ok-btn" nButton theme="primary" [label]="i18n.ok" (click)="onOk()"></button>
        <button id="create-local-unix-user-cancel-btn" nButton [label]="i18n.cancel" (click)="hide()"></button>
    </n-footer>
</n-slide-window>
